<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">园区服务</li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">园区服务</div>
        <div class="navigation-link-2s" style="line-height: 2">
          <a style="margin-left: 180px" href="#" class="navigation-link-2" :class="{ active: activeLink === 'patent' }"
             @click.prevent="selectLink('patent')">重点园区认定</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '2'  }"-->
<!--             @click.prevent="selectLink('2')">产业链专业园区评定</a>-->
          <span class="separator">|</span>
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'trademark' }"
             @click.prevent="selectLink('trademark')">企业的孵化园区</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '4' }"-->
<!--             @click.prevent="selectLink('4')">区级众创空间认定</a>-->
        </div>
        <div class="navigation-link-2s">

        </div>
      </div>
    </div>


    <!--重点园区认定start******************************************************************************************************************************************************************************-->
    <div v-show="patentShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 1500px">
        <div>
          <span class="titleSty">重点产园区认定产品说明
          <span class="spanSty">Description</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2">
                1、园区产业定位明确，符合湖北省产业政策和产业布局规划，符合城市发展总体规划；<br>
                2、园区管理主体明晰，具有专业的招商、运营、服务机构，有统一、规范的服务标准和体系，具有相应的资金实力；<br>
                3、园区建筑面积在5万平方米以上，配套较完善，包括水、电、气、信息等基础设施及餐饮、食堂生活服务配套等；<br>
                4、承诺遵守市、区投资推广部门制定的有关园区管理规定。
              </p>
            </div>
          </div>
          <div class="image-container2">
            <img src="./yuanqu.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>


        <!--产品功能-->
        <div style="position: absolute;margin-top: 260px;width: 1255px">
          <span class="titleSty">产品功能
          <span class="spanSty">Product function</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 320px;">
          <div class="achievements-container">
            <div class="achievement-item">
              <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
              <span>获得市级园区认定资质</span>
            </div>
            <div class="achievement-item">
              <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
              <span>提高园区运营实力、完善运营服务体系</span>
            </div>
            <div class="achievement-item">
              <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
              <span>提升运营机构运营品牌力和影响力</span>
            </div>
            <div class="achievement-item">
              <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
              <span>为运营机构扩增新的项目增加载体运营实力背书</span>
            </div>
          </div>
        </div>

        <!--服务流程-->
        <div style="position: absolute;margin-top: 500px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Service process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 580px;">
          <div class="flowchart-container-updated">
            <img src="./gj008.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step1-updated">专业咨询</div>
              <div class="step-text step2-updated">材料收集整理</div>
              <div class="step-text step3-updated">税务师审计初稿</div>
              <div class="step-text step4-updated">税务师审核</div>
              <div class="step-text step5-updated">出具报告</div>
              <div class="step-text step6-updated">办理完成</div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 820px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 870px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--重点园区认定end******************************************************************************************************************************************************************************-->


    <!--企业的孵化园区start*******************************************************************************************************************************************************************************-->
    <div v-show="trademarkShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 2400px">
        <div>
          <span class="titleSty">企业孵化园区介绍
          <span class="spanSty">Introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2">
                &nbsp;&nbsp;&nbsp;&nbsp;孵化园，亦被称为企业孵化器，是一个专为科技公司初期发展提供支持的场所。它不仅配备了完善
                的办公设施，还享受着税收优惠政策，助力这些企业稳健成长。孵化园的核心理念在于扶持创业初期的
                新生企业，尤其是由大学生创立的公司。通过提供物理空间、基础设施以及全方位的服务支持，孵化园
                致力于降低创业者的风险和成本，进而提升创业成功率，推动科技成果的商业化，并致力于培养出一批
                又一批成功的企业和企业家。同时，孵化园也兼具服务性和公益性，为区域经济的发展注入源源不断的
                活力。
              </p>
            </div>
          </div>
          <div class="image-container2">
            <img src="./fuhua.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>

        <div class="service-container" style="position: absolute;margin-top: 200px;width: 675px">
          <!-- 孵化场地 -->
          <div class="service-item">
            <img src="./ff001.png" alt="孵化场地图标" class="service-icon">
            <p class="service-text">有孵化场地</p>
          </div>

          <!-- 公共设施 -->
          <div class="service-item">
            <img src="./ff001.png" alt="公共设施图标" class="service-icon">
            <p class="service-text">有公共设施</p>
          </div>

          <!-- 孵化服务 -->
          <div class="service-item">
            <img src="./ff001.png" alt="孵化服务图标" class="service-icon">
            <p class="service-text">能提供孵化服务</p>
          </div>

          <!-- 科技型中小企业 -->
          <div class="service-item">
            <img src="./ff001.png" alt="科技型中小企业图标" class="service-icon">
            <p class="service-text">面向新创办的科技型中小企业</p>
          </div>
        </div>

        <!--企业孵化器的作用-->
        <div style="position: absolute;margin-top: 380px;width: 1255px">
          <span class="titleSty">企业孵化器的作用
          <span class="spanSty">Role</span></span>
        </div>

        <div class="tj-container">
          <div class="tj-box">
            <div class="tj-header">降低创业成本</div>
            <div class="tj-content">
              <p>为初创企业提供必要的物理空间和基础设施，减少创业者在办公场所、设备等方面的初期投资。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">提供专业指导</div>
            <div class="tj-content" style="padding-right: 0">
              <p>通过经验丰富的导师和顾问团队，</p>
              <p>为企业提供战略规划、市场分析、</p>
              <p>产品开发等方面的专业建议。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">促进网络建设</div>
            <div class="tj-content">
              <p>帮助初创企业建立与潜在客户、供应商、合作伙伴、投资者等关键角色的联系。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">提高资源效率</div>
            <div class="tj-content">
              <p>集中资源和服务，使初创企业能够以较低成本获取到它们单独难以获得的资源和服务。</p>
            </div>
          </div>
        </div>

        <div class="tj-container">
          <div class="tj-box">
            <div class="tj-header">增加曝光机会</div>
            <div class="tj-content">
              <p>通过孵化器组织的活动和平台，提高企业在市场上的可见度。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">促进知识共享</div>
            <div class="tj-content">
              <p>在同一孵化器内的企业可以相互学习和分享经验，形成积极的创业文化和社区。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">提高融资可能性</div>
            <div class="tj-content">
              <p>孵化器的信誉和网络可以帮助企业更容易地吸引投资者的注意，增加融资机会。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">加速产品开发</div>
            <div class="tj-content">
              <p>通过提供技术支持和研发资源，帮助企业加快产品从概念到市场的过程。</p>
            </div>
          </div>
        </div>

        <div class="tj-container">
          <div class="tj-box">
            <div class="tj-header">增强企业生存能力</div>
            <div class="tj-content">
              <p>通过提供综合服务和支持，提高初创企业的生存率和成长性。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">促进就业和经济发展</div>
            <div class="tj-content">
              <p>成功的初创企业可以创造就业机会，促进地方经济增长和创新。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">培养创业精神</div>
            <div class="tj-content">
              <p>孵化器提供了一个鼓励创新和接受失败的环境，有助于培养更多的创业者和创业精神。</p>
            </div>
          </div>

          <div class="tj-box">
            <div class="tj-header">推动技术创新</div>
            <div class="tj-content">
              <p>特别是在高科技领域的孵化器，可以促进新技术研发和商业化，推动产业升级和经济发展。</p>
            </div>
          </div>
        </div>

        <!--产品功能-->
        <div style="position: absolute;margin-top: 60px;width: 1255px">
          <span class="titleSty">孵化园的服务
          <span class="spanSty">Service</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 130px;">

          <div class="service-container-0">
            <!-- 场地提供 -->
            <div class="service-item-0 service-item1">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon1">
              <span class="service-text service-text1">场地提供</span>
            </div>

            <!-- 创业指导 -->
            <div class="service-item-0 service-item2">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon2">
              <span class="service-text service-text2">创业指导</span>
            </div>

            <!-- 资金支持 -->
            <div class="service-item-0 service-item3">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon3">
              <span class="service-text service-text3">资金支持</span>
            </div>

            <!-- 政策咨询 -->
            <div class="service-item-0 service-item4">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon4">
              <span class="service-text service-text4">政策咨询</span>
            </div>

            <!-- 法律和财务服务 -->
            <div class="service-item-0 service-item5">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon5">
              <span class="service-text service-text5">法律和财务服务</span>
            </div>

            <!-- 培训和教育 -->
            <div class="service-item-0 service-item6">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon6">
              <span class="service-text service-text6">培训和教育</span>
            </div>

            <!-- 网络资源 -->
            <div class="service-item-0 service-item7">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon7">
              <span class="service-text service-text7">网络资源</span>
            </div>

            <!-- 技术支持 -->
            <div class="service-item-0 service-item8">
              <img src="./zu13.png" alt="打钩图标" class="check-icon check-icon8">
              <span class="service-text service-text8">技术支持</span>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 250px;width: 707px">
          <span class="titleSty">园区照片
          <span class="spanSty">Park photos</span></span>
        </div>
        <div class="image-gallery" style="width: 1192px;position: absolute; margin-top: 330px;">
          <!-- 左侧大图 -->
            <el-image :src="require('./p1.jpg')" :preview-src-list="srcList"  class="large-image"></el-image>

          <!-- 右侧小图 -->
          <div class="small-images">
            <el-image  class="small-image" :src="require('./p2.png')"   :preview-src-list="srcList"></el-image>
            <el-image  class="small-image" :src="require('./p3.jpg')"   :preview-src-list="srcList"></el-image>
            <el-image  class="small-image" :src="require('./p4.png')"   :preview-src-list="srcList"></el-image>
            <el-image  class="small-image" :src="require('./p5.jpg')"   :preview-src-list="srcList"></el-image>
            <el-image  class="small-image" :src="require('./p6.jpg')"   :preview-src-list="srcList"></el-image>
            <el-image  class="small-image" :src="require('./p7.jpg')"   :preview-src-list="srcList"></el-image>
          </div>
        </div>


        <div style="position: absolute;margin-top: 780px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 830px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--企业的孵化园区end*******************************************************************************************************************************************************************************-->


    <!--记账报税******************************************************************************************************************************************************************************-->
    <div v-show="copyrightShow">

    </div>
    <!--记账报税******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'parkServices.css';
</style>
<script>
import AdvantageList from '../common/advantageList.vue';

export default {
  components: {AdvantageList},
  data() {
    return {
      activeLink: 'patent',
      patentShow: true,
      trademarkShow: false,
      copyrightShow: false,
      softwareShow: false,
      srcList:[
        require("./p1.jpg"),
        require("./p2.png"),
        require("./p3.jpg"),
        require("./p4.png"),
        require("./p5.jpg"),
        require("./p6.jpg"),
        require("./p7.jpg"),
      ]
    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.patentShow = false;
      this.trademarkShow = false;
      this.copyrightShow = false;
      this.softwareShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'patent') {
        this.patentShow = true;
      } else if (link === 'trademark') {
        this.trademarkShow = true;
      } else if (link === 'copyright') {
        this.copyrightShow = true;
      } else if (link === 'software') {
        this.softwareShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/parkServices/parkServices.vue